// import { Routes } from '@angular/router';

// export const routes: Routes = [];


import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MobileoptionsComponent } from './mobileoptions/mobileoptions.component';
import { ReviewComponent } from './review/review.component';
import { AboutComponent } from './about/about.component';
import { CreatemymenuComponent } from './createmymenu/createmymenu.component';
import { MarriagemenuComponent } from './marriagemenu/marriagemenu.component';
import { MobilemarriagemenuComponent } from './mobilemarriagemenu/mobilemarriagemenu.component';
import { FindusComponent } from './findus/findus.component';
import { AdminPageComponent } from './admin-page/admin-page.component';
import { CarouselComponent } from './carousel/carousel.component';


export const routes: Routes = [
       { path: '', redirectTo: 'home', pathMatch: 'full' },
       { path: 'home',component: HomeComponent,pathMatch:"full" },
       { path: 'mhome',component: MobileoptionsComponent,pathMatch:"full" },
       { path: 'reviews', component: ReviewComponent },
       { path: 'about', component: AboutComponent },
       { path: 'createmymenu', component: CreatemymenuComponent },
       { path: 'marriagemenu/:id', component: MarriagemenuComponent },
       { path: 'mobilemarriagemenu/:id', component: MobilemarriagemenuComponent },
       { path: 'admin-page',component:AdminPageComponent},
       { path: 'findus',component:FindusComponent},
       { path: 'carousel',component:CarouselComponent},
       { path: '**', redirectTo: 'home' }
];



